<template>
  <img class="tw-min-h-screen tw-h-full tw-absolute tw-z-0 tw-inset-0 tw-w-full tw-filter tw-blur-3xl tw-opacity-20" :src="src" alt="">
</template>
<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    }
  }
}
</script>
